<template>
  <div :class="['wrapper']">
    <q-btn-toggle
      v-if="this.floorsPlan?.length"
      v-model="this.activeMode"
      toggle-color="primary"
      :options="this.modes"
      @update:model-value="onModeChange"
      size="sm"
      style="margin-bottom: 25px;"
    />
    <div
      v-for="floor in this.floorsPlan"
      :key="floor.floor_map_id"
      :class="['floor', { 'floorInactive': this.activeColorId && this.activeColorId !== floor.colour_id }]"
    >
      <CustomCheckbox
        v-if="this.showCheckbox && this.activeMode === 'all'"
        :value="floor?.is_selected"
        @change="(value) => onCheckboxChange(floor, value)"
        :small="true"
        :disable="!floor?.floor_map_id || (this.activeColorId && this.activeColorId !== floor.colour_id)"
      />
      <span
        class="floorNum"
        :style="{
        display: 'flex', alignItems: 'center', justifyContent: 'center',}"
        >{{ floor.floor }}</span
      >
      <div class="apartments">
        <template v-if="this.activeMode === 'all'">
          <div
            v-for="apartment in floor.flat"
            :key="apartment.flat_id"
            :class="['apartment']"
            @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
            :style="`background-color: ${this.getCellColor(apartment, floor)}`"
          >
            <span class="apartmentRoomCnt">
              {{ apartment.room_cnt }}
            </span>
            <span class="apartmentInfo">{{ apartment.area }} м²</span>
            <span class="apartmentInfo">кв. {{ apartment.flat_num }}</span>
            <span
              v-if="!!apartment.remont_id"
              class="apartmentInfo"
              style="font-size: 11px;"
            >
              <q-tooltip> Ремонт ID </q-tooltip>#{{ apartment.remont_id }}</span
            >
            <q-icon
              v-if="apartment.has_okk_defect"
              name="fa-solid fa-triangle-exclamation"
              class="warningIcon"
            >
              <q-tooltip> Имеются замечания ОКК </q-tooltip>
            </q-icon>
          </div>
        </template>
        <template v-else-if="this.activeMode === 'entrancePayments'">
          <div
            style="padding-right: 15px; border-right: 2px solid #ccc; margin-right: 10px;"
          >
            <div
              @click="() => this.onApartmentClick && this.onApartmentClick({floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
              :class="['apartment', 'apartmentAlt', ]"
            >
              <template
                v-for="(item, index) in floor?.floor_payment_status"
                :key="index"
              >
                <div
                  class="segment"
                  :style="{ height: item?.status_percent + '%', backgroundColor: this.hexToRgba(item.status_colour, 0.6) }"
                ></div>
                <div
                  class="segment-label"
                  :class="['segment-label', { 'segment-label__top': index === 0, 'segment-label__middle': index === 1 }]"
                >
                  <Amount :value="item.status_sum || 0" />
                  <template v-if="index === 2">
                    <br />
                    ({{ item?.status_percent + '%' }})
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div
            v-for="apartment in floor.flat"
            @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
            :class="['apartment', 'apartmentAlt', ]"
          >
            <span
              class="apartmentInfo apartmentInfoFlat"
              >{{ apartment.flat_num }}</span
            >
            <template
              v-for="(item, index) in apartment?.payment_status"
              :key="index"
            >
              <div
                class="segment"
                :style="{ height: item?.status_percent + '%', backgroundColor: this.hexToRgba(item.status_colour, 0.6) }"
              ></div>
              <div
                class="segment-label"
                :class="['segment-label', { 'segment-label__top': index === 0, 'segment-label__middle': index === 1 }]"
              >
                <Amount :value="item.status_sum || 0" />
                <template v-if="index === 2">
                  <br />
                  ({{ item?.status_percent + '%' }})
                </template>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div
            style="padding-right: 15px; border-right: 2px solid #ccc; margin-right: 10px;"
          >
            <div
              @click="() => this.onApartmentClick && this.onApartmentClick({floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
              :class="['apartment', 'apartmentAlt', ]"
            >
              <template
                v-for="(item, index) in floor?.floor_work_status"
                :key="index"
              >
                <div
                  class="segment"
                  :style="{ height: item?.status_percent + '%', backgroundColor: this.hexToRgba(item.status_colour, 0.6) }"
                ></div>
                <div
                  class="segment-label"
                  :class="['segment-label', { 'segment-label__top': index === 0, 'segment-label__middle': index === 1 }]"
                >
                  <Amount :value="item.status_cnt || 0" />
                  <template v-if="index === 2">
                    <br />
                    ({{ item?.status_percent + '%' }})
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div
            v-for="apartment in floor.flat"
            @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
            :class="['apartment', 'apartmentAlt', ]"
          >
            <span
              class="apartmentInfo apartmentInfoFlat"
              >{{ apartment.flat_num }}</span
            >
            <template
              v-for="(item, index) in apartment?.work_status"
              :key="index"
            >
              <div
                class="segment"
                :style="{ height: item?.status_percent + '%', backgroundColor: this.hexToRgba(item.status_colour, 0.6) }"
              ></div>
              <div
                class="segment-label"
                :class="['segment-label', { 'segment-label__top': index === 0, 'segment-label__middle': index === 1 }]"
              >
                <Amount :value="item.status_cnt || 0" />
                <template v-if="index === 2">
                  <br />
                  ({{ item?.status_percent + '%' }})
                </template>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="gprInfo" v-if="floor.gpr_plan_start || floor.gpr_fact_start">
        <div v-if="floor.gpr_plan_start" class="gprBlock">
          <div class="gprLabel">Период план:</div>
          <div class="gprDates">{{ floor.gpr_plan_start }} - {{ floor.gpr_plan_end }}</div>
        </div>
        <div v-if="floor.gpr_fact_start" class="gprBlock" style="margin-top: 8px;">
          <div class="gprLabel">Период факт:</div>
          <div class="gprDates" style="display: flex; align-items: center; flex-wrap: wrap;">
            <span>{{ floor.gpr_fact_start }}</span>
            <span v-if="floor.gpr_deviation_start !== undefined && floor.gpr_deviation_start !== null && floor.gpr_deviation_start !== 0"
                  :class="{'text-red': floor.gpr_deviation_start > 0, 'text-green': floor.gpr_deviation_start < 0}"
                  style="font-size: 11px; margin-left: 2px; margin-right: 4px; font-weight: 600;">
              ({{ floor.gpr_deviation_start > 0 ? '+' : '' }}{{ floor.gpr_deviation_start }} дн)
            </span>
            <span style="margin: 0 4px;">-</span>
            <span>{{ floor.gpr_fact_end }}</span>
            <span v-if="floor.gpr_deviation_end !== undefined && floor.gpr_deviation_end !== null && floor.gpr_deviation_end !== 0"
                  :class="{'text-red': floor.gpr_deviation_end > 0, 'text-green': floor.gpr_deviation_end < 0}"
                  style="font-size: 11px; margin-left: 2px; font-weight: 600;">
              ({{ floor.gpr_deviation_end > 0 ? '+' : '' }}{{ floor.gpr_deviation_end }} дн)
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import { hexToRgba } from "@/services";
import Amount from "@/components/common/Amount.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox";

export default {
  name: 'ResidentialApartmentsList',
  components: {CustomSelect, Amount, CustomCheckbox},
  props: ['onApartmentClick', 'floorsPlan', 'mode', 'updateData', 'params', 'addData', 'getFloorData', 'showCheckbox'],
  data() {
    return {
      loading: {},
      colors: [],
      activeMode: 'doneWorks',
      activeColorId: null,
      modes: [{value: 'doneWorks', label: 'Выполненные работы'}, {value: 'entrancePayments', label: 'Выплачено'}, {value: 'all', label: 'Квартиры'}]
    };
  },
  methods: {
    hexToRgba,
    getCellColor(_, floor) {
      if(this.activeColorId && this.activeColorId !== floor.colour_id) {
        return '#f0f0f0'
      }
      return hexToRgba(floor.hex_code, .5)
    },
    onModeChange(mode) {
      this.activeMode = mode
    },
    onCheckboxChange(floor, value) {
      const {floor: key} = floor
      if(!this.activeColorId)
        this.activeColorId = floor.colour_id
      const updatedData = this.floorsPlan.map(floor => {
        if (floor.floor === key) {
          return { ...floor, is_selected: value };
        }
        return floor;
      });
      this.updateData(updatedData)
    },
  },
  watch: {
    floorsPlan(newValue) {
      const isSelectedExist = newValue.some(floor => floor.is_selected);
      if(!isSelectedExist)
        this.activeColorId = null
    },
    mode() {
      this.activeColorId = null
      const updatedData = this.floorsPlan.map(floor => ({...floor, is_selected: false }));
      this.updateData(updatedData)
    }
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;
  padding-right: 0;

  &__paddingless {
    padding: 0;
  }
}
.floor {
  margin-bottom: 5px; display: flex; gap: 15px; align-items: center;
  transition: .3s all;
}
.floorInactive {
  opacity: 0.5;
}
.floorNum {
  font-size: 14px; font-weight: 400; color: #333;
  width: 18px;;
}
.apartments {
  display: flex; gap: 5px; align-items: center;
}
.apartment {
  width: 90px;
  height: 90px; padding: 5px;
  border-radius: 12px;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .3s all;
  position: relative;
    cursor: pointer;

  &:hover {
    background-color: #d2dce3;
  }

  &__small {
    width: 70px;
    height: 70px;
  }
}
.apartmentAlt {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding: 0;
}
.apartmentRoomCnt {
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.apartmentInfo {
  font-size: 12px;
  color: #474747;
}
.apartmentInfoFlat {
  font-size: 11px;
  position: absolute;
  top: 2px;
  right: 5px;
}
.warningIcon {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #f37416;
}
.segment {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.segment-label {
  color: #000;
  text-align: center;
  pointer-events: none;
  font-size: 11px;
  line-height: 12px;
  position: absolute;
  bottom: 12px;
  font-weight: 700;
  z-index: 10;

  &__top {
    color: #404040;
    bottom: unset;
    top: 25px;
  }

  &__middle {
    color: #F2C037;
    bottom: unset;
    top: calc(50% - 5px);
  }
}
.gprInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
}
.gprBlock {
  font-size: 11px;
  color: #555;
  line-height: 1.2;
}
.gprLabel {
  font-weight: 600;
  color: #444;
  font-size: 11px;
}
.gprDates {
  color: #666;
  font-size: 11px;
}
</style>
